import { render, staticRenderFns } from "./NearMatchList.vue?vue&type=template&id=c2d67f9c&scoped=true&"
import script from "./NearMatchList.vue?vue&type=script&lang=js&"
export * from "./NearMatchList.vue?vue&type=script&lang=js&"
import style0 from "./NearMatchList.vue?vue&type=style&index=0&id=c2d67f9c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d67f9c",
  null
  
)

export default component.exports